import React from 'react';

import { v4 as uuidv4 } from 'uuid';

import { Resource } from '../../../../common/constants/resource';
import { TColumnsResolver } from '../../../../common/types/TColumnsResolver';
import { DoctorInfo } from '../../../tasks/types/rx';
import styles from '../../styles.module.scss';
import {
  dateToString,
  numberToOrdinal,
} from '../../utilities/formattingUtilities';
import { RxDetailsSeverity } from './RxDetailsSeverity';

export const RxDetailsColumnResolver: TColumnsResolver = (
  col: any,
  row: any,
): string | JSX.Element | undefined => {
  let cellValue;
  if (col.name === 'severity') {
    cellValue = <RxDetailsSeverity severity={row.severity} />;
  } else if (col.name === 'fillDates') {
    cellValue = formatFillDates(row.fillDates);
  } else if (col.name === 'indications') {
    cellValue = formatIndications(row.indication);
  } else if (col.name === 'physician') {
    cellValue = formatDoctorInfo(row.doctor);
  } else if (col.name === 'quantity') {
    cellValue = `${row.quantity} (${row.days} days)`;
  } else if (col.name === 'drugName') {
    cellValue = <span className={styles.TaskSubtitle}>{row.drugName}</span>;
  }
  return cellValue;
};

/*
Encode string as HTML and render.
 */
const renderHTML = (rawHTML: string) => {
  const doc = new DOMParser().parseFromString(rawHTML, 'text/html');
  return doc.documentElement.textContent;
};

const formatIndications = (indications: string[]) => (
  <div>
    {indications.map((indication: string) => (
      <div key={uuidv4()} className={styles.LineMarginBottom}>
        {renderHTML(`${indication}&#46;`)}
      </div>
    ))}
  </div>
);

/*
Information for some fields HTML encoded characters like &amp;.
So, we need to decode the HTML.
 */
const formatDoctorInfo = (doctorInfo: DoctorInfo) => (
  <div key={uuidv4()}>
    <div className={styles.LineMarginBottom}>
      {doctorInfo.speciality && renderHTML(doctorInfo.speciality)}
    </div>
    <div className={styles.LineMarginBottom}>
      {doctorInfo.speciality && renderHTML(doctorInfo.name)}
    </div>
    <div className={styles.LineMarginBottom}>
      {doctorInfo.address && renderHTML(doctorInfo.address)}
    </div>
    <div className={styles.LineMarginBottom}>
      {doctorInfo.phone && renderHTML(doctorInfo.phone)}
    </div>
  </div>
);

const formatFillDates = (fillDates: string[]) => {
  if (fillDates.length === 0) {
    return Resource.NORA_M_DASH;
  }
  const ordinalFillDates = fillDates.map(
    (fillDate: string, idx: number, data: string[]) => (
      <div className={styles.FillDates} key={uuidv4()}>
        <span className={styles.OrdinalNumber}>
          {numberToOrdinal(data.length - idx)}
        </span>
        <span className={styles.FormattedDate}>{dateToString(fillDate)}</span>
      </div>
    ),
  );
  return (
    <div key={uuidv4()}>
      {ordinalFillDates.map(ordinalFillDate => (
        <div className={styles.LineMarginBottom} key={uuidv4()}>
          {ordinalFillDate}
        </div>
      ))}
    </div>
  );
};
